import { fabric } from 'fabric';

export function drawLayoutStroke({ layout_options, width, height, canvas }) {
  canvas.getObjects().forEach(function (o) {
    if (o.id === 'layout_stroke') {
      canvas.remove(o);
    }
  });

  const layout_stroke_width = layout_options ? parseInt(layout_options.stroke_width) : 1;
  const layout_stroke_color = layout_options ? layout_options.stroke_color : '#A9A9A9';
  const rect = new fabric.Rect({
    id: 'layout_stroke',
    top: 0,
    left: 0,
    order: 0,
    width: width - layout_stroke_width,
    height: height - layout_stroke_width,
    fill: '#00000000',
    stroke: layout_stroke_color,
    strokeWidth: +layout_stroke_width,
    selectable: false,
    evented: false,
  });
  
  canvas.add(rect);
  canvas.bringToFront(rect);
}